<div *ngIf="activeStepContent">
  <ng-container [ngTemplateOutlet]="activeStepContent"></ng-container>
</div>
